import { useState, useEffect, useCallback } from 'react';
import { useRouter } from 'next/router';

//* HOC's
import { withUIContext } from 'context';

//* Style
import FeedbackStyle from './style';

//* Components
import Text from 'components/common/Text';
import FeedbackPopup from 'components/common/FeedbackPopup';

const Feedback = ({ type, typeId, openPopup }) => {
    //! Router
    const router = useRouter();

    //! State
    const [selected, setSelected] = useState(null);

    useEffect(() => {
        const storedFeedback = JSON.parse(localStorage.getItem('feedback'));

        if (storedFeedback != null) {
            const existItem = storedFeedback.find((item) => item.type == type && item.typeId == typeId);
            if (existItem) {
                setSelected(existItem.rating);
            }
        }
    }, [router.asPath]);

    //! Handle feedback
    const handleFeedback = useCallback(
        (rating) => {
            if (!selected) {
                setSelected(rating);

                const storedFeedback = JSON.parse(localStorage.getItem('feedback')) || [];

                const feedbackData = {
                    type,
                    typeId,
                    rating: rating,
                };

                localStorage.setItem('feedback', JSON.stringify([...storedFeedback, feedbackData]));

                openPopup(<FeedbackPopup feedbackData={feedbackData} />);
            }
        },
        [selected, openPopup]
    );

    return (
        <FeedbackStyle>
            <div className='feedback-flex-block'>
                <Text
                    className={`p font-ping-medium feedback-text`}
                    text={'giveUsFeedback'}
                />

                <div className='buttons-block'>
                    <svg
                        viewBox='0 0 64 64'
                        xmlns='http://www.w3.org/2000/svg'
                        className={`${selected === 'like' ? 'active' : ''} ${selected !== null ? 'disable' : ''}`}
                        onClick={() => handleFeedback('like')}>
                        <g
                            id='Group_42638'
                            data-name='Group 42638'
                            transform='translate(-1616 -19071.773)'>
                            <circle
                                id='Ellipse_574'
                                data-name='Ellipse 574'
                                cx='32'
                                cy='32'
                                r='32'
                                transform='translate(1616 19071.773)'
                                fill='#fff'
                            />
                            <g
                                id='thumbs-up-svgrepo-com'
                                transform='translate(1632 19084.102)'>
                                <g
                                    id='Group_42637'
                                    data-name='Group 42637'
                                    transform='translate(0 0)'>
                                    <g
                                        id='Group_42636'
                                        data-name='Group 42636'>
                                        <path
                                            id='Path_63114'
                                            data-name='Path 63114'
                                            d='M191.125,186.223a2.128,2.128,0,0,0,1.024-1.887,2.97,2.97,0,0,0-2.685-2.987h-7.515a1.532,1.532,0,0,1-1.614-1.611.537.537,0,0,0-1.074,0,2.589,2.589,0,0,0,2.685,2.685h7.519a1.912,1.912,0,0,1,1.611,1.913c0,.279,0,1.129-1.67,1.313a.537.537,0,0,0,.059,1.071,1.611,1.611,0,0,1,0,3.222h-1.074a.537.537,0,1,0,0,1.074,1.611,1.611,0,0,1,0,3.222h-1.611a.537.537,0,1,0,0,1.074,1.116,1.116,0,0,1,1.074,1.074,1.147,1.147,0,0,1-1.074,1.074h-8.056a6.79,6.79,0,0,1-3.983-.96,8.891,8.891,0,0,0-3.459-1.183.537.537,0,0,0-.153,1.063,7.86,7.86,0,0,1,3.093,1.06,7.852,7.852,0,0,0,4.5,1.093h8.056a2.233,2.233,0,0,0,2.148-2.148,2.106,2.106,0,0,0-.3-1.084,2.684,2.684,0,0,0,1.777-4.454,2.684,2.684,0,0,0,.726-4.625Z'
                                            transform='translate(-159.925 -169.534)'
                                            fill='#15233b'
                                            stroke='#15233b'
                                            strokeWidth='0.5'
                                        />
                                        <path
                                            id='Path_63116'
                                            data-name='Path 63116'
                                            d='M171.2,39.564c1.6,0,3.614-1.781,4.676-2.843,2.306-2.306,2.306-5.171,2.306-9.51a.494.494,0,0,1,.537-.537c1.857,0,2.685.828,2.685,2.685V35.8a.537.537,0,0,0,1.074,0V29.36c0-2.46-1.3-3.759-3.759-3.759a1.558,1.558,0,0,0-1.611,1.611c0,4.215,0,6.759-1.991,8.75-1.559,1.559-3.06,2.528-3.917,2.528a.537.537,0,0,0,0,1.074Z'
                                            transform='translate(-159.926 -25.601)'
                                            fill='#15233b'
                                            stroke='#15233b'
                                            strokeWidth='0.5'
                                        />
                                        <path
                                            id='Path_63117'
                                            data-name='Path 63117'
                                            d='M9.13,213.333H.537A.537.537,0,0,0,0,213.87v16.112a.537.537,0,0,0,.537.537H9.13a.537.537,0,0,0,.537-.537V213.87A.537.537,0,0,0,9.13,213.333Zm-.537,16.111H1.074V214.407H8.593v15.037Z'
                                            transform='translate(0 -201.518)'
                                            fill='#15233b'
                                            stroke='#15233b'
                                            strokeWidth='0.5'
                                        />
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>

                    <svg
                        xmlns='http://www.w3.org/2000/svg'
                        viewBox='0 0 64 64'
                        className={`${selected === 'dislike' ? 'active' : ''} ${selected !== null ? 'disable' : ''}`}
                        onClick={() => handleFeedback('dislike')}>
                        <g
                            id='Group_42639'
                            data-name='Group 42639'
                            transform='translate(-1696 -19071.773)'>
                            <circle
                                id='Ellipse_573'
                                data-name='Ellipse 573'
                                cx='32'
                                cy='32'
                                r='32'
                                transform='translate(1696 19071.773)'
                                fill='#fff'
                            />
                            <g
                                id='thumb-down-svgrepo-com'
                                transform='translate(1712 19095.613)'>
                                <g
                                    id='Group_42635'
                                    data-name='Group 42635'
                                    transform='translate(0 0)'>
                                    <g
                                        id='Group_42634'
                                        data-name='Group 42634'>
                                        <path
                                            id='Path_63111'
                                            data-name='Path 63111'
                                            d='M191,37.833a2.667,2.667,0,0,0-.722-4.6,2.667,2.667,0,0,0-1.765-4.426,2.092,2.092,0,0,0,.3-1.077,2.219,2.219,0,0,0-2.135-2.135h-8a7.8,7.8,0,0,0-4.473,1.087,7.812,7.812,0,0,1-3.074,1.053.534.534,0,1,0,.152,1.057,8.836,8.836,0,0,0,3.437-1.175,6.748,6.748,0,0,1,3.958-.954h8a1.14,1.14,0,0,1,1.067,1.067,1.109,1.109,0,0,1-1.067,1.067.534.534,0,1,0,0,1.067h1.6a1.6,1.6,0,0,1,0,3.2.534.534,0,1,0,0,1.067h1.067a1.6,1.6,0,1,1,0,3.2.534.534,0,0,0-.058,1.064c1.659.182,1.659,1.027,1.659,1.3a1.9,1.9,0,0,1-1.6,1.9h-7.471a2.573,2.573,0,0,0-2.668,2.668.534.534,0,0,0,1.067,0,1.522,1.522,0,0,1,1.6-1.6h7.471a2.951,2.951,0,0,0,2.668-2.969A2.115,2.115,0,0,0,191,37.833Z'
                                            transform='translate(-159.993 -25.599)'
                                            fill='#15233b'
                                            stroke='#15233b'
                                            strokeWidth='0.5'
                                        />
                                        <path
                                            id='Path_63112'
                                            data-name='Path 63112'
                                            d='M181.874,267.735a.533.533,0,0,0-.534.534v6.4c0,1.845-.823,2.668-2.668,2.668a.49.49,0,0,1-.534-.534c0-4.311,0-7.158-2.291-9.45-1.055-1.055-3.061-2.825-4.647-2.825a.534.534,0,1,0,0,1.067c.851,0,2.343.963,3.892,2.512,1.978,1.978,1.978,4.506,1.978,8.695a1.549,1.549,0,0,0,1.6,1.6c2.444,0,3.736-1.291,3.736-3.736v-6.4A.533.533,0,0,0,181.874,267.735Z'
                                            transform='translate(-159.994 -249.59)'
                                            fill='#15233b'
                                            stroke='#15233b'
                                            strokeWidth='0.5'
                                        />
                                        <path
                                            id='Path_63113'
                                            data-name='Path 63113'
                                            d='M9.072,25.6H.534A.533.533,0,0,0,0,26.134v16.01a.533.533,0,0,0,.534.534H9.072a.533.533,0,0,0,.534-.534V26.134A.533.533,0,0,0,9.072,25.6ZM8.539,41.61H1.067V26.667H8.539V41.61Z'
                                            transform='translate(0 -25.6)'
                                            fill='#15233b'
                                            stroke='#15233b'
                                            strokeWidth='0.5'
                                        />
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                </div>
            </div>
        </FeedbackStyle>
    );
};

export default withUIContext(Feedback, ['openPopup']);
